import { __assign } from "tslib";
import { PatientActionTypes, } from '../actions/patient.actions';
export var initialState = {
    patients: {},
};
export function reducer(state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case PatientActionTypes.LoadPatientInformationSuccess: {
            return __assign(__assign({}, state), { patients: __assign(__assign({}, state.patients), (_a = {}, _a[action.payload.patientId] = action.payload.response, _a)) });
        }
        case PatientActionTypes.ClearAllPatientInformation: {
            return initialState;
        }
        default:
            return state;
    }
}
// Selectors
export var getPatients = function (state) { return state.patients; };
